import script from "./EventItems.vue?vue&type=script&setup=true&lang=js"
export * from "./EventItems.vue?vue&type=script&setup=true&lang=js"

import "./EventItems.vue?vue&type=style&index=0&id=995bbd40&lang=scss"

const __exports__ = script;

export default __exports__